(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["melody-shared-header"]) return;
  try {
    
(() => {
  const observers = new WeakMap();
  const initialize = () => {
    document.querySelectorAll('.ml-sticky-header-section').forEach(section => {
      if (observers.has(section)) return;
      const measure = () => {
        if (section.isConnected) {
          document.documentElement.style.setProperty('--ml-sticky-header-height', `${section.getBoundingClientRect().height}px`);
        }
      };
      const observer = new ResizeObserver(measure);
      observer.observe(section);
      observers.set(section, observer);
      measure();
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    const observer = observers.get(event.target);
    if (observer) {
      observer.disconnect();
      observers.delete(event.target);
    }
  });
})();

(() => {
  if (window.melodyHeaderCartCount) return;
  window.melodyHeaderCartCount = true;
  let revision = 0;
  let running = false;
  let scheduled = false;
  const paint = count => {
    if (!Number.isSafeInteger(count) || count < 0) return;
    document.querySelectorAll('[data-ml-cart-link]').forEach(link => {
      const badge = link.querySelector('[data-ml-cart-count]');
      if (!badge) return;
      const changed = badge.textContent !== String(count);
      badge.textContent = String(count);
      badge.hidden = count === 0;
      const label = `${link.dataset.cartLabel} (${count})`;
      link.setAttribute('aria-label', label);
      const status = link.parentElement.querySelector('[data-ml-cart-status]');
      if (changed && status) status.textContent = label;
    });
  };
  const read = async () => {
    scheduled = false;
    if (running) return;
    running = true;
    let version;
    do {
      version = revision;
      const link = document.querySelector('[data-ml-cart-link]');
      if (!link) break;
      try {
        const response = await fetch(link.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart count unavailable');
        const cart = await response.json();
        if (version === revision) paint(cart.item_count);
      } catch {}
    } while (version !== revision);
    running = false;
  };
  const refresh = () => {
    revision += 1;
    if (running || scheduled) return;
    scheduled = true;
    queueMicrotask(read);
  };
  for (const event of ['cart:updated', 'ajaxProduct:added', 'shopify:section:load']) {
    document.addEventListener(event, refresh);
  }
  window.addEventListener('pageshow', refresh);
  window.addEventListener('focus', refresh);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') refresh();
  });
  refresh();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (event) {
        runMySectionCode();
      });
    } else {
      runMySectionCode();
    }
    function runMySectionCode() {
      document.querySelector('.tc-carousel').style.display = 'block';
      var flkty = new Flickity('.tc-carousel', {
        wrapAround: true,
        pageDots: false,
        adaptiveHeight: true,
        avoidReflow: true,
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
